<template>
  <div>
    <Dropzone
    id="customdropzone"
    :awss3="awss3"
    :options="dropzoneOptions"
    :useCustomSlot="true"
    @vdropzone-sending="sending"
    @vdropzone-s3-upload-error="s3UploadError"
    @vdropzone-success="dropzoneSuccess"
    @vdropzone-queue-complete="onComplete"
    @vdropzone-s3-upload-success="s3UploadSuccess"
    @vdropzone-total-upload-progress="updateProgress">
    <!-- @vdropzone-success-multiple="test2" -->
    <!-- @vdropzone-total-upload-progress="test" -->
    <!-- @vdropzone-success-multiple="s3UploadSuccess" -->
      <!-- <div class="dropzone-custom-content">
         <h3 class="dropzone-custom-title">Arrastra y suelta tus archivos aquí</h3>
        <div class="subtitle">... o da clic y selecciona de tu computadora</div>
      </div> -->
      <!-- <v-btn
        color="white"
        class="primary--text custom-round"
        :height="70"
        :width="600"
      >
      <div style="white-space: normal;">
        <h1><v-icon x-large>mdi-cloud-upload-outline</v-icon> Seleccionar xml</h1>
        <strong class="txt-highlight font-weight-black">Ahorra tiempo, sube todas tus facturas en una sola carga</strong>
      </div>
      </v-btn> -->
      <v-btn
        id="btnUpload"
        width="100%"
        color="light-grey"
        class="subtitle-2 black--text"
        :class="{
          'subtitle-2': $vuetify.breakpoint.mdAndDown
        }"
        block
        rounded
      >
        <v-icon class="black--text">mdi-upload</v-icon>
        <span v-if="!$vuetify.breakpoint.md"><strong>Subir</strong> facturas</span>
      </v-btn>
    </Dropzone>
    <!-- <v-btn
      v-if="loading"
      color="primary"
      class="d-block mb-8 mt-2 mx-auto custom-round white--text"
      :loading="loadingProcess"
      :disabled="loadingProcess"
      :height="50"
      :width="400"
    >
      <h1>Carga completa <v-icon>mdi-emoticon</v-icon></h1>
      <template v-slot:loader>
        <v-progress-linear
          color="primary"
          class="d-block my-5 custom-round"
          rounded
          :value="uploadProgress"
          :height="50"
        ></v-progress-linear>
      </template>
    </v-btn> -->
    <!-- <v-btn
        color="white"
        class="primary--text custom-round"
        :height="50"
        :width="600"
        @click="openDisconectSat"
        v-if="$store.getters.user.SATsyncActive && $store.getters.user.syncAllowed"
    >
      <h1><v-icon x-large>mdi-sync-off</v-icon> &nbsp;&nbsp;&nbsp;Dejar de sincronizar con SAT</h1>
    </v-btn> -->
    <!-- <v-btn
        color="white"
        class="primary--text custom-round"
        :height="50"
        :width="600"
        @click="openSat"
        v-else
    >
      <h1><v-icon x-large>mdi-sync</v-icon> Sincronizar con SAT</h1>
    </v-btn> -->
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
// const getTemplate = () => `
//   <div class="dz-preview dz-file-preview custom">
//     <div class="dz-image">
//       <div data-dz-thumbnail-bg></div>
//     </div>
//     <div class="dz-details custom-details">
//       <div class="dz-filename"><span data-dz-name></span></div>
//     </div>
//     <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress="" style="width: 20%;"></span></div>
//     <div class="dz-error-message"><span data-dz-errormessage=""></span></div>
//     <div class="dz-success-mark">    <svg width="20px" height="20px" viewBox="0 0 70 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>      </g>    </svg>  </div>
//     <div class="dz-error-mark">    <svg width="20px" height="20px" viewBox="0 0 70 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>        </g>      </g>    </svg>  </div>
//   </div>
// `

export default {
  props: ['acceptedFiles', 'overlay', 'clientRFC'],
  components: {
    Dropzone
  },
  data () {
    return {
      loading: false,
      files: [],
      uploadedFiles: [],
      uploadProgress: 0,
      dropzoneOptions: {
        thumbnailWidth: 10, // px
        thumbnailHeight: 10,
        maxFilesize: 1.5,
        uploadMultiple: false,
        // parallelUploads: 1,
        acceptedFiles: this.acceptedFiles,
        // previewTemplate: getTemplate()
        previewsContainer: false
      },
      awss3: {
        signingURL: (file) => {
          this.loading = true
          // The server REST endpoint we setup earlier
          const key = `${process.env.VUE_APP_BASE_API}/api/signedUrl?filename=${file.name}&clientRFC=${this.clientRFC}`
          // Save this for later use
          // this.files[file.name] = file
          const ext = file.name.split('.').pop()
          if (ext.toLowerCase() === 'xml') {
            this.files.push(file)
          }
          return key
        },
        headers: {},
        params: {},
        // We'll take care of pusting the image details to our server on our own
        sendFileToServer: false
      }
    }
  },
  mounted () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        // this.$emit('update:overlay', !this.overlay)
        this.$emit('update:stopAnimations', false)
      }
    })
  },
  methods: {
    sending (file) {
      if (!file.accepted) {
        file.xhr.timeout = 1
      }
    },
    // Fired AFTER a file is successfully uploaded to S3
    dropzoneSuccess (file, res) {
      // console.info('==================dropzoneSuccess')

      // const { type: contentType, size, height, width, s3Signature: { key: path } } = file
      /// ...fill in details of saving data to your server
    },
    allDropzoneSuccess (res) {
      console.info(res)
    },
    s3UploadError (errorMessage) {
      // console.info('==================s3UploadError')
      // Show an error message on failure
      console.info(errorMessage)
    },
    s3UploadSuccess (s3ObjectLocation) {
      this.uploadedFiles.push({ uri: s3ObjectLocation })
      // let that = this
      // setTimeout(() => {
      //   that.uploadProgress = Object.keys(this.files).length / this.uploadedFiles.length * 100
      // }, 5000)
      // console.info('  type s3ObjectLocation', typeof (s3ObjectLocation))
      // console.info('==================s3UploadSuccess')
      // Show a message after uploaded to S3?
      // console.info('this.files', this.files.length)
      // if (this.files.length === this.uploadedFiles.length) {
      //   this.$emit('successS3Upload', s3ObjectLocation)
      //   this.$emit('successS3Upload', this.uploadedFiles)
      // }
      // console.info('s3ObjectLocation', s3ObjectLocation)
    },
    async updateProgress (totaluploadprogress, totalBytes, totalBytesSent) {
      this.uploadProgress = totaluploadprogress
      // if (totaluploadprogress === 100) {
      // console.info('  ->', this.uploadedFiles)
      // }
    },
    async onComplete () {
      const uploadedFiles = this.files.map(item => {
        const url = new URL(item.s3Signature.key, item.s3Url)

        return Object.assign({}, {
          fileName: item.name,
          uri: url.href
        })
      })
      await this.$emit('successS3Upload', uploadedFiles)
      this.files = []
      this.loadingProcess = false
    },
    openSat () {
      this.$emit('onSatOpen')
    },
    openDisconectSat () {
      this.$emit('onDisconectSat')
    }
  }
}
</script>

<style>
  /*#dropzone { min-height: auto; max-height: auto; overflow-y: auto; padding: 0 !important; }*/
  /*#dropzone .dz-preview { min-height: auto !important; width: 10px !important; display: inline-block !important; }*/
  .dropzone .dz-message { margin: 0 !important; }
  /*.dropzone .dz-preview { height: 10px !important; width: 10px !important; }*/

  #customdropzone {
    padding: 0px !important;
    background-color: transparent;
    border: none;
  }
  .dropzone {
    min-height: 10px !important;
  }

  .custom-round {
    border-radius: 20px !important;
  }

  .dropzone .custom{
    margin: 6px !important;
    min-height: 0px !important;
    height: 10px !important;
    width: 70px !important;
  }
  .dropzone .custom-details {
    font-size: 10px!important;
  }
  .dz-size {
    font-size: 10px!important;
  }
  .txt-highlight {
    text-transform: none;
    color: red;
  }
  .animated-button {
    -webkit-animation-name: shakeY;
    -webkit-animation-duration: 1.5s;
    -webkit-animation-iteration-count: 1;
    /*-webkit-animation-timing-function: linear;*/
    -webkit-animation-delay: 0s;
    /*-webkit-animation-direction: alternate;*/
  }
</style>
